import {
	requests
}from '../../../../api/agent'

export default {
	getPagedAll   : (params) => requests.getWithParams('/RePriceFormationOrder/getPagedAll', params),
	getPaged      : (params) => requests.getWithParams('/RePriceFormationOrder/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/RePriceFormationOrder/getPagedAudit', params),
	getList       : (params) => requests.getWithParams('/RePriceFormationOrder/getList', params),
	create        : (params) => requests.post('/RePriceFormationOrder/create', params),
	delete        : (params) => requests.getWithParams('/RePriceFormationOrder/delete', params),
	update        : (params) => requests.post('/RePriceFormationOrder/update', params),
	restore       : (params) => requests.getWithParams('/RePriceFormationOrder/restore', params)
}